import { render, staticRenderFns } from "./WorkOrdersCard.vue?vue&type=template&id=1b6e6805"
import script from "./WorkOrdersCard.vue?vue&type=script&lang=js"
export * from "./WorkOrdersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports